<template>
  <div>
    <h4 class="title">Информация о гостях</h4>
    <div class="row" v-for="(guest, index) in guests" v-bind:key="index">
      <div class="col-md-3">
        <div class="form-group is-empty" :data-vv-scope="'guest_'+index">
          <input :validate="{required: index===0}"
                 :class="{'input': true, 'has-error': errors.has('lastName_'+index) }"
                 type="text" v-model="guest.last_name" :name="'lastName_'+index" class="form-control"
                 placeholder="Фамилия*">
          <span class="material-input"></span>
          <span v-show="errors.has('lastName_'+index)" class="help text-danger has-error">
            {{ formatErrorMessage(errors['lastName_' + index], 'lastName_' + index)}}
          </span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group is-empty">
          <input type="text" v-model="guest.first_name" name="firstName" class="form-control" placeholder="Имя">
          <span class="material-input"></span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group is-empty">
          <input type="text" v-model="guest.middle_name" name="middleName" class="form-control" placeholder="Отчество">
          <span class="material-input"></span>
        </div>
      </div>
      <div class="col-md-2" v-if="index === 0 && guestCount < totalGuestCount">
        <button class="btn btn-just-icon btn-round btn-success" v-on:click="addGuest()">
          <i class="material-icons">add</i>
          <div class="ripple-container"></div>
        </button>
      </div>
      <div class="col-md-2" v-if="index > 0">
        <button class="btn btn-just-icon  btn-round btn-danger" v-on:click="removeGuest(index)">
          <i class="material-icons">close</i>
          <div class="ripple-container"></div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GuestForm',

  props: [
    'guestsComposition',
  ],
  data() {
    return {
      guests: [
        {},
      ],
      errors: new Map(),
    };
  },
  computed: {
    guestCount() {
      return this.guests.length;
    },
    totalGuestCount() {
      const res = this.guestsComposition.reduce((a, b) => ({ persons: a.persons + b.persons }));
      return res.persons;
    },
    ...mapGetters(['reservationCreated']),
  },
  methods: {
    formatErrorMessage(message, fieldName) {
      if (message) {
        return message.replace(fieldName, '');
      }
      return '';
    },
    addGuest() {
      this.guests.push({
        first_name: '',
        middle_name: '',
        last_name: '',
      });
    },
    removeGuest(index) {
      this.guests.splice(index, 1);
    },
    clearForm() {
      this.guests.splice(1, 100);
      this.guests[0] = {
        first_name: '',
        middle_name: '',
        last_name: '',
      };
    },
  },
  watch: {
    guests: {
      // eslint-disable-next-line no-unused-vars
      handler(val, oldVal) {
        this.$emit('guestsChanged', this.guests.filter(g => g.last_name != null && g.last_name !== ''));
      },
      deep: true,
    },
    guestsComposition() {
      // Check guest input field count when changed guest count.
      if (this.totalGuestCount < this.guestCount) {
        while (this.totalGuestCount !== this.guestCount) {
          this.guests.pop();
        }
      }
    },
    reservationCreated(v) {
      if (v) this.clearForm();
    },
  },
};
</script>
